export const FontDefinitionDefault = {
  h1: {
    fontSize: {
      value: 2,
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.4,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h2: {
    fontSize: {
      value: 1.5,
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.4,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h3: {
    fontSize: {
      value: 1.313,
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.4,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h4: {
    fontSize: {
      value: 1.063,
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.6,
      unit: 'text'
    },
    fontWeight: {
      value: 700,
      unit: 'text'
    }
  },
  h5: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h6: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  p: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  hero: {
    fontSize: {
      value: 2.5,
      unit: 'rem'
    },
    letterSpacing: {
      value: 0,
      unit: 'text'
    },
    lineHeight: {
      value: 1.25,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  subhero: {
    fontSize: {
      value: 1.5,
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.4,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  div: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  span: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  b: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  i: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  body: {
    fontSize: {
      value: 1.063,
      unit: 'rem'
    },
    lineHeight: {
      value: 1.6,
      unit: 'text'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    }
  }
};

// export const FontDefaults: {
//   [ele: string]: {
//     [cssProp: string]: number | string
//   }
// } = definitionToCSSJS(FontDefinitionDefault);

export const FontDefinitionDefaultMobile = {
  h1: {
    fontSize: {
      value: 1.5,
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.4,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h2: {
    fontSize: {
      value: '1.33',
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.4,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h3: {
    fontSize: {
      value: '1.2',
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: '1.6',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h4: {
    fontSize: {
      value: '1.08',
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.6,
      unit: 'text'
    },
    fontWeight: {
      value: 700,
      unit: 'text'
    }
  },
  h5: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  h6: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  p: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  hero: {
    fontSize: {
      value: '1.6',
      unit: 'rem'
    },
    letterSpacing: {
      value: 0,
      unit: 'text'
    },
    lineHeight: {
      value: 1.25,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  subhero: {
    fontSize: {
      value: '1.35',
      unit: 'rem'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    },
    lineHeight: {
      value: 1.4,
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  div: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  span: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  b: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  i: {
    fontSize: {
      value: '',
      unit: 'text'
    },
    letterSpacing: {
      value: '',
      unit: 'text'
    },
    lineHeight: {
      value: '',
      unit: 'text'
    },
    fontWeight: {
      value: '',
      unit: 'text'
    }
  },
  body: {
    fontSize: {
      value: 1.063,
      unit: 'rem'
    },
    lineHeight: {
      value: 1.6,
      unit: 'text'
    },
    letterSpacing: {
      value: 0.2,
      unit: 'px'
    }
  }
};
